import { makeStyles, Typography } from "@material-ui/core";
import Alert, { Color } from "@material-ui/lab/Alert";
import { FC } from "react";

interface AlertBlockInterface {
  text: string | undefined;
  theme: Color;
}

export const AlertBlock: FC<AlertBlockInterface> = ({ text, theme }) => {
  const classes = useStyles();
  return (
    <Alert
      data-testid="testCheckTableCellPaint"
      icon={false}
      severity={theme}
      className={classes.root}
    >
      <Typography className={classes.text}>{text}</Typography>
    </Alert>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(0.5, 1),
    "& .MuiAlert-message": {
      padding: 0,
    },
    "&.MuiAlert-standardSuccess": {
      background: "#A8DABC",
      color: "#145E32",
    },
    "&.MuiAlert-standardWarning": {
      background: "#F5D87A",
      color: "#7A5200",
    },
    "&.MuiAlert-standardError": {
      background: "#F5AAAA",
      color: "#881414",
    }
  },
  text: {
    fontWeight: 600,
  }
}));
